import { RegisterRequestsGridView } from '~/components/customers/register-requests';
import { PageContainer } from '~/components/page-container';

export function RegisterRequests() {
	return (
		<PageContainer>
			<RegisterRequestsGridView />
		</PageContainer>
	);
}
